import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-exit',
  templateUrl: './icon-exit.component.html',
  styleUrls: ['./icon-exit.component.scss'],
})
export class IconExitComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
